<template>
    <div class="bg-lightest col-sm-12 py-4 mt-4 reservations-min-height">
        <div class="options d-flex align-items-center my-3 pl-3">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="row">
                            <div class="d-flex col-sm-4 pl-0">
                                <div class="d-flex w-100">
                                    <input class="bg-lighter flexGrow1" type="text" v-model="filters.searchString" @input="onFilterChange" placeholder="Search customer, ticket, voucher">
                                    <button class="btn wider blue ml-3 w-80" @click='onFilterChange'>Search</button>
                                </div>
                            </div>

                            <div class="col-sm-4 d-flex pl-0 align-items-center">
                                <button class="btn wider bg-dark ml-1" v-if="getShowInvoiceOption === true && (getBulkSelectedIds.length > 0 || bulkSelectAll)" @click="openOptions">Invoice ({{bulkInvoiceTotal}})</button>
                            </div>

                            <div class="col-sm-4 d-flex justify-content-end align-items-center pr-0">
                                <export :exportOptions="exportOptions"></export>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-12 mt-3">
                        <div class="row d-flex align-items-start">
                            <div class="d-flex flexGrow1">
                                <div class="col-md-2 d-flex flex-row align-items-center pl-0" v-if="getSlimFilters">
                                    <multiselect
                                        ref="productFilter"
                                        v-model="filters.productId"
                                        :options="treatedProductList"
                                        :multiple="true"
                                        :close-on-select="false"
                                        :clear-on-select="false"
                                        :preserve-search="false"
                                        placeholder="All Products"
                                        label="name"
                                        track-by="id"
                                        selectLabel=""
                                        deselectLabel=""
                                        selectedLabel=""
                                        class="w-100"
                                        @input="onFilterChange"
                                    >

                                        <template slot="selection" slot-scope="{ values, search, isOpen }">
                                            <span class="multiselect__single"  v-if="values.length > 1" v-tooltip.auto="values.length + ' products selected'">{{ values.length }} products selected</span>
                                            <span class="multiselect__single" v-else-if="values.length == 1 " v-tooltip.auto="values[0].name">{{values[0].name}} </span>
                                        </template>

                                        <template slot="option" slot-scope="props">
                                            <i v-if="filters.productId.filter(i => {return i.id == props.option.id}).length" class="far fa-check-square"></i>
                                            <i v-else class="far fa-square"></i>
                                            <span v-tooltip.auto="props.option.name">{{props.option.name}}</span>
                                        </template>
                                    </multiselect>
                                </div>

                                <div class="col-md-2 d-flex flex-row align-items-center pl-0">
                                    <multiselect
                                        ref="locationFilter"
                                        v-model="filters.locations"
                                        :options="locations"
                                        :multiple="true"
                                        :close-on-select="false"
                                        :clear-on-select="false"
                                        :preserve-search="false"
                                        track-by="id"
                                        label="name"
                                        selectLabel=""
                                        deselectLabel=""
                                        selectedLabel=""
                                        class="w-100"
                                        placeholder="All Locations"
                                        @input="onFilterChange"
                                    >

                                        <template slot="selection" slot-scope="{ values, search, isOpen }">
                                            <span class="multiselect__single"  v-if="values.length > 1" v-tooltip.auto="values.length + ' locations selected'">{{ values.length }} locations selected</span>
                                            <span class="multiselect__single" v-else-if="values.length == 1 " v-tooltip.auto="values[0].name">{{values[0].name}} </span>
                                        </template>

                                        <template slot="option" slot-scope="props">
                                            <i v-if="filters.locations.filter(i => {return i.name == props.option.name}).length" class="far fa-check-square"></i>
                                            <i v-else class="far fa-square"></i>
                                            <span v-tooltip.auto="props.option.name">{{props.option.name}}</span>
                                        </template>
                                    </multiselect>
                                </div>

                                <div class="col-md-2 d-flex flex-row align-items-center pl-0" v-if="editedAgentList && editedAgentList.length > 0">
                                    <seller-picker 
                                        class="w-100" 
                                        ref="sellerSelector" 
                                        :inlcudeWidget="true" 
                                        placeholder="All Sellers" 
                                        @input="sellerChanged" 
                                        @deselect="deselectSeller"
                                        :optionsType="'new'">
                                    </seller-picker>
                                </div>

                                <div class="d-flex pr-4">
                                    <button class="btn tertiary reservations-filters-height d-flex align-items-center justify-content-center position-relative" @click="openFilters(3)">
                                        <i class="fas fa-sliders-h fs-large"></i>
                                        <span>More Filters</span>
                                        <div class="reservations-filters-circle bg-color-1" v-show="hasSelectedReservationFilters"></div>
                                    </button>
                                </div>
                            </div>

                            <div>
                                <div class="d-flex flex-row align-items-center pr-3">
                                    <button class="btn tertiary reservations-filters-height" @click='clearFilters'>Clear All</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-sm-12 d-flex justify-content-between my-4" v-if="hasLoadedOnce">
            <div class="bold dark">
                <span v-if="allowSelectRows && pageInfo && reservationsArr.length > 0">Selected {{ bulkInvoiceTotal }} of {{ pageInfo.totalItemCount }} | </span>
                <span>Results per page:</span>
                
                <select v-on:change="resultsPerPageChanged" v-model="resultsPerPage" class="results-per-page border-light">
                    <option v-for="option in resultsPerPageOptions" v-bind:value="option.pSize">
                        {{ option.pSizeText }}
                    </option>
                </select>
            </div>

            <div>
                <uib-pagination 
                    v-if="pageInfo && pageInfo.pageCount > 1"
                    v-model="paginationComputed"
                    :total-items="pageInfo.totalItemCount"
                    :items-per-page="resultsPerPage"
                    :boundary-link-numbers="false"
                    :max-size="7"
                    @change="onPageChange">
                </uib-pagination>
            </div>
        </div>

        <list v-if="!isLoadingReservations && reservationsArr" :header="header" :body="body" :rows="reservationsArr" :showNoDataMessage="false" class="px-3"></list>

        <div class="col-sm-12 d-flex justify-content-end my-4" v-if="pageInfo && reservationsArr.length > 0">
            <uib-pagination 
                v-if="pageInfo && pageInfo.pageCount > 1"
                v-model="paginationComputed"
                :total-items="pageInfo.totalItemCount"
                :items-per-page="resultsPerPage"
                :boundary-link-numbers="false"
                :max-size="7"
                @change="onPageChange">
            </uib-pagination>
        </div>

        <div v-if="!isLoadingReservations && hasLoadedOnce && reservationsArr.length == 0" class="text-center p-4 mt-5">
            <span class="dark font-weight-600 fs-large">No reservations found</span>
        </div>

        <div v-if="isLoadingReservations || !hasLoadedOnce" class="p-4 my-5 text-center">
            <loader></loader>
        </div>
    </div>
</template>

<script>
    import mixin from '@/mixins/reservationsLogicMixin'
    import List from '@/tools/list/baseList'
    import Loader from '@/tools/loaders/loader1'
    import Export from '@/tools/ExportV2'
    import SellerPicker from '@/tools/SellerPicker'
    import Multiselect from 'vue-multiselect'
    import VueDatepicker from 'vuejs-datepicker'
    import extendedVSelect from '@/extends/vue-select'
    import _ from 'lodash'

    export default {
        name: 'ReservationsBySaleDate',
        mixins: [ mixin ],
        props: {
            reservationMainFilters: { 
                type: Object, 
                required: true 
            },
            pagination: {
                type: Object,
                default: () => ({ currentPage: 1 })
            }
        },
        data () {
            return {
                config: {
                    viewId: 3,
                    listUrl: '/api/booking/SalesList',
                    downloadUrl: '/api/booking/SalesDownload'
                },
                hasLoadedOnce: false
            }
        },
        methods : {
            getReservationsPaginated: _.debounce(function() {
                this.$set(this, 'bulkSelectAll', false);

                if (this.isLoadingReservations) return;

                this.isLoadingReservations = true;
                    
                axios.get(this.config.listUrl, {
                    params: this.requestFilterOptions
                }).then(response => {
                    if (response.status == 200) {
                        this.pageInfo = response.data.pageInfo;
                        this.reservationsArr = this.selectSelectedReservations(response.data.result);
                    }
                })
                .catch(() => {})
                .finally(() => {
                    this.isLoadingReservations = false;
                    this.hasLoadedOnce = true;
                });
            }, 500)
        },
        computed: {
            requestFilterOptions() {
                const reservationsFilters = this.getReservationsFilters;

                Object.assign(this.filters, {
                    resourceId: reservationsFilters.resourceId,
                    paymentStatus: reservationsFilters.paymentStatus,
                    countryId: reservationsFilters.countryId,
                    status: reservationsFilters.status,
                    currentCheckboxPickup: reservationsFilters.currentCheckboxPickup,
                    currentCheckboxNote: reservationsFilters.currentCheckboxNote,
                    categories: reservationsFilters.categories
                });

                return {
                    supplierId: this.account.supplierId,
                    page: this.pagination.currentPage,
                    pageSize: this.resultsPerPage,
                    's.String': this.filters.searchString,
                    's.ProductId': this.filters.productId && this.filters.productId.length > 0 ? this.filters.productId.map(item => item.id) : null,
                    's.ResourceId': this.filters.resourceId && this.filters.resourceId.length > 0 ? this.filters.resourceId.map(item => item.id) : null,
                    's.locations': this.filters.locations && this.filters.locations.length > 0 ? this.filters.locations.map(item => item.name) : null,
                    's.audienceTypes': this.filters.categories && this.filters.categories.length > 0 ? this.filters.categories.map(item => item.name) : null,
                    's.PaymentStatus': this.filters.paymentStatus && this.filters.paymentStatus.length > 0 ? this.filters.paymentStatus.map(item => item.id) : null,
                    's.StatusList': this.filters.status && this.filters.status.length > 0 ? this.filters.status.map(item => item.id) : null,
                    's.withTransport': this.filters.currentCheckboxPickup ? true : null,
                    's.withNote': this.filters.currentCheckboxNote ? true : null,
                    's.eventId': this.filters.eventId,
                    's.dateStart': this.reservationMainFilters.dateRange[0],
                    's.dateEnd': this.reservationMainFilters.dateRange[1],
                    's.countryId': this.filters.countryId,
                    's.sellerType': this.filters.sellerType,
                    's.channelType': this.filters.sellerType,
                    's.sellerId': this.filters.sellerId
                }
            },
            header() {
                return {
                    selection: {
                        active: this.allowSelectRows,
                        event: (event) => {
                            this.bulkSelectAll = event;
                            this.selectCurrentPage(event);
                        }
                    },
                    selectAll: this.bulkSelectAll,
                    list: {
                        productColorSign: ' ',
                        reservation: 'Reservation',
                        created: 'Created',
                        departure: 'Departure',
                        pax: 'PAX',
                        totalPrice: 'Total',
                        statusReservation: 'Status',
                        statusPayment: 'Payment',
                        fullName: 'Client Name',
                        seller: 'Seller',
                        checkin: 'Check|NoShow',
                        icons: ' ',
                    },
                };
            },
            body() {
                return {
                    selection: {
                        active: this.allowSelectRows,
                        event: (event, reservation) => {
                            if (this.getBulkSelectedIds.length > 0 && this.getBulkSelectedIds.includes(reservation.id)) {
                                this.removeFromBulkSelectedIds([reservation.id]);
                            } else {
                                this.addToBulkSelectedIds([reservation.id]);
                            }
                        }
                    },
                    customRowEvent: (reservation) => {this.view(reservation.id) },
                    customCells: {
                        productColorSign: this.cellProductColorSign,
                        reservation: this.cellReservation,
                        departure: this.cellDeparture,
                        created: this.cellCreated,
                        pax: this.cellPax,
                        totalPrice: this.cellTotalPrice,
                        statusReservation: this.cellStatusReservation,
                        statusPayment: this.cellStatusPayment,
                        fullName: this.cellFullName,
                        seller: this.cellSeller,
                        checkin: this.cellCheckin,
                        icons: this.cellIcons
                    }
                }
            },
        },
        components: { 
            List, 
            Loader, 
            Export, 
            SellerPicker, 
            Multiselect, 
            VueDatepicker, 
            vSelect: extendedVSelect 
        }
    }
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// ReservationsBySaleDate.vue?ce4cb020